var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "inline"
    },
    height: "1.5em",
    viewBox: "0 -960 960 960",
    width: "1.5em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.85-140v-45.39h123.46v-187.69q-95.54-13.61-147.58-77.19-52.04-63.58-52.04-149.73v-220h444.62v220q0 86.15-52.04 149.73-52.04 63.58-147.58 77.19v187.69h123.46V-140h-292.3Zm-30.77-482.69h353.84v-151.92H303.08v151.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWine);
export default __webpack_public_path__ + "static/media/wine.2200f5d5354f42712491cde72571d1df.svg";
export { ForwardRef as ReactComponent };